TS.ns('WL');

WL.engineScoringViewModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        me.filterByPartnerType = ko.computed(function () {
            if (me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_TYPE)
                return true;
            return false;
        });
         
        me.filterByPartnerBaseType = ko.computed(function () {
            if (me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_BASE_TYPE)
                return true;
            return false; 
        });

        me.filterByFormula = ko.computed(function () {
            if (me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_FORMULA_WITH_DOCSTRUCTURE || me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_FORMULA)
                return true;
            return false;
        });
          
        me.UseAllAttributesGridVisible = ko.computed(function () {
            if (me.Document.UseAllAttributes())  
                return false;
            return true;
        });

        me.formulaVariablesVisible = ko.computed(function () {
            if (me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_FORMULA)
                return true;
            return false;
        });

        me.KnockoutFormulaVisible = ko.computed(function () {
            var knockoutCriteriaList = me.getDomainProperty('grdKnockoutCriteriaCollection_Property');

            if (knockoutCriteriaList == null)
                return false;

            if (knockoutCriteriaList.SelectedItem() != null && knockoutCriteriaList.SelectedItem().CriteriaId() != null)                
                return true;

            return false;
        });

        me.watchProperty(me.Document.UseAllAttributes, me.onUseAllAttributesChanged, me);
        //me.watchProperty(me.Document.FilterTypeId, me.onFilterTypeChanged, me);

        var filterTypeList = me.getDomainProperty('lkpFilterType_Property');
        if (filterTypeList != null) {
            filterTypeList.on('selectionChanged', me.onFilterTypeChanged, me);
            filterTypeList.autoSelect = true;
        }

        var targetContextList = me.getDomainProperty('lkpTargetContext_Property');
        if (targetContextList != null) {
            targetContextList.on('selectionChanged', me.onTargetContextChanged, me);
        }

        var externalSystemList = me.getDomainProperty('grdEngineScoringXExternalSystem_Property');
        if (externalSystemList != null) {
            externalSystemList.on('cellValueChanged', me.onExternalSystemChanged, me);
        }

        var complementaryRuleBrowser = me.getDomainProperty('grdComplementaryRules_Property');

        if (complementaryRuleBrowser)
            complementaryRuleBrowser.getFieldByName('gcEngineComplementaryRule_Field').on('propertyChanged', me.onComplementaryRuleChanged, me);

        var classificationList = me.getDomainProperty('grdClassifications_Property');
        if (classificationList != null) {
            classificationList.on('addNew', me.onClassificationAdded);
        }

        var categoriesList = me.getDomainProperty('grdCategories_Property');
        if (categoriesList != null) {
            categoriesList.on('addNew', me.onCategoryAdded);
        }

        var financialIndicatorList = me.getDomainProperty('grdFinancialIndicators_Property');
        if (financialIndicatorList != null) {
            financialIndicatorList.on('addNew', me.onFinancialIndicatorAdded);
        }

        var attributesListSearch = me.getDomainProperty('AttributeDescriptionSearch_Property');
        if (attributesListSearch)
            attributesListSearch.on('selectionChanged', me.onAttributeListSearchChanged, me);

        var engineScoringXAttributeList = me.getDomainProperty('grdEngineScoringXAttributeCollection_Property');

        if (engineScoringXAttributeList) {
            cat = engineScoringXAttributeList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'DeleteAttribute';
            newCmd['Text'] = 'Delete attribute';
            newCmd['handler'] = '_deleteAttribute';
            newCmd['IconCode'] = 'minus';

            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'AddAllAttributes';
            newCmd['Text'] = 'Add all attributes';
            newCmd['handler'] = '_addAllAttributes';
            newCmd['IconCode'] = 'plus';

            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'RemoveAllAttributes';
            newCmd['Text'] = 'Remove all attributes';
            newCmd['handler'] = '_removeAllAttributes';
            newCmd['IconCode'] = 'minus';

            if (!me.ReadOnly())
                cat.push(newCmd);
        }
    },

    onFilterTypeChanged: function (newValue) {
        var me = this;

        me.filterByPartnerType = ko.computed(function () {
            if (me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_TYPE)
                return true;
            return false;
        });

        me.filterByPartnerBaseType = ko.computed(function () {
            if (me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_BASE_TYPE)
                return true;
            return false;
        });

        me.filterByFormula = ko.computed(function () {
            if (me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_FORMULA_WITH_DOCSTRUCTURE || me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_FORMULA)
                return true;
            return false;
        });

        me.formulaVariablesVisible = ko.computed(function () {
            if (me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_FORMULA)
                return true;
            return false;
        });

        me.performServerCommand({ cmd: 'PartnerFilterTypeChanged', submitModel: true, extraData: {}, blockUI: true });
    },

    onTargetContextChanged: function (newValue) {
        var me = this;

            if (me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_FORMULA_WITH_DOCSTRUCTURE || me.Document.FilterTypeId() == WL.Config.FilterTypeEngineScoring.PARTNER_FORMULA)
                me.performServerCommand({ cmd: 'CreateContextFormulaOptions', submitModel: true, extraData: {}, blockUI: true });
    },

    onExternalSystemChanged: function (newValue) {
        var me = this,
            externalSystemList = me.getDomainProperty('grdEngineScoringXExternalSystem_Property');

        if (newValue.sender.SelectedItem()) {
            externalSystemList.SelectedItem().ResultTypeCode(newValue.sender.SelectedItem().ResultTypeCode);
        }
    },

    _addAllAttributes: function () {
        var me = this; 

        me.performServerCommand({ cmd: 'AddAllAttributes', submitModel: true, extraData: {}, blockUI: true });
    },

    _removeAllAttributes: function () {
        var me = this;

        me.performServerCommand({ cmd: 'RemoveAllAttributes', submitModel: true, extraData: {}, blockUI: true });
    },

    _deleteAttribute: function () {
        var me = this;

        var engineScoringXAttributeList = me.getDomainProperty('grdEngineScoringXAttributeCollection_Property');

        if (engineScoringXAttributeList.SelectedItem() == null)
            return;

        me.performServerCommand('DeleteAttribute', true, { EngineAttributeId: engineScoringXAttributeList.SelectedItem().EngineAttributeId() });
    },

    onUseAllAttributesChanged: function (newValue) {
        var me = this;

        me.performServerCommand({
            cmd: 'UseAllAttributesChanged',
            submitModel: true,
            blockUI: false
        });
    },

    onComplementaryRuleChanged: function (selectedRecord) {
        var me = this;

        var complementaryRuleList = me.getDomainProperty('grdComplementaryRules_Property');
        complementaryRuleList.SelectedItem().ComplementaryRuleDescription(selectedRecord.sender.SelectedItem().Description);
        complementaryRuleList.SelectedItem().ComplementaryRuleName(selectedRecord.sender.SelectedItem().ComplementaryRuleName);
    },

    onClassificationAdded: function (e) {
        var me = this,
         rec = e.item,
         owner = me._getOwner();

        rec.DisplayPageId = new ko.observable(owner.DefaultDisplayPageId());
        rec.DisplayPageName = new ko.observable(owner.DefaultDisplayPageName());
        rec.AttributeCollection = ko.observableArray([]);
        rec.ScoringCollection = ko.observableArray([]);
        rec.ClassificationCommentCollection = ko.observableArray([]);
        rec.FinancialIndicatorCollection = ko.observableArray([]);
    },

    onCategoryAdded: function (e) {
        var me = this,
         rec = e.item;

        rec.IsMandatory(true);
    },

    onFinancialIndicatorAdded: function (e) {
        var me = this,
         rec = e.item;

        rec.IsMandatory(true);
    },

    onAttributeListSearchChanged: function (newValue) {
        var me = this;

        setTimeout(function() {
            me.performServerCommand({
                cmd: 'AddAttributeForEvaluation',
                submitModel: true,
                blockUI: true
            });
        }, 0)
    } 

});